import { render } from "./QuizType5.vue?vue&type=template&id=3a418f0c&scoped=true"
import script from "./QuizType5.vue?vue&type=script&lang=js"
export * from "./QuizType5.vue?vue&type=script&lang=js"

import "./QuizType5.vue?vue&type=style&index=0&id=3a418f0c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a418f0c"]])

export default __exports__